import { Injectable, inject } from '@angular/core';
import { Observable, Subject } from 'rxjs';

import { ApiService } from '@core/providers/http';

import {
  PostoComandoEstatisticasModel,
  PainelGeralEstatisModel,
  EquipaEstatisticasModel,
  ClientesEstatisModel,
  EfetivoEstatisModel,
  OcorrenciaEstaModel,
  PostoEstatisModel,
  SideBarEstatisticasModel,
} from './estatisticas-models';

// SERVICE PARA O POSTO DE COMANDO
@Injectable({
  providedIn: 'root',
})
export class PostoComandoEstatisticas {
  private readonly apiService = inject(ApiService);
  private readonly endpoint = '/api/Dashboard/PostoDeComando';

  obterPostoComandoEstaisticas(): Observable<PostoComandoEstatisticasModel> {
    return this.apiService.get<PostoComandoEstatisticasModel>(this.endpoint);
  }
}

// SERVICE PARA OS BADGES DO MENU LATERAL
@Injectable({
  providedIn: 'root',
})
export class SideBarEstatisticas {
  private readonly apiService = inject(ApiService);
  private readonly endpoint = '/api/Dashboard/Badges';
  private readonly refreshSubject = new Subject<void>();
  readonly refreshRequested$ = this.refreshSubject.asObservable();

  getBadges(): Observable<SideBarEstatisticasModel> {
    return this.apiService.get<SideBarEstatisticasModel>(this.endpoint);
  }

  requestRefresh(): void {
    this.refreshSubject.next();
  }
}

// SERVICE PARA O PAINEL PRINCIPAL
@Injectable({
  providedIn: 'root',
})
export class PainelGeralEstatisticas {
  private readonly apiService = inject(ApiService);
  private readonly endpoint = '/api/Dashboard/PainelGeral';

  obterPainelGeralEstatisticas(): Observable<PainelGeralEstatisModel> {
    return this.apiService.get<PainelGeralEstatisModel>(this.endpoint);
  }
}

// SERVICE PARA O BADGE DE EQUIPAMENTOS
@Injectable({
  providedIn: 'root',
})
export class EquipamentoEstatisticas {
  private readonly apiService = inject(ApiService);
  private readonly endpoint = '/api/DashBoard/EquipamentosEstatisticas';

  obterEquipaEstatisticas(): Observable<EquipaEstatisticasModel> {
    return this.apiService.get<EquipaEstatisticasModel>(this.endpoint);
  }
}

// SERVICE PARA O BADGE DE POSTOS
@Injectable({
  providedIn: 'root',
})
export class PostoEstatisticas {
  private readonly apiService = inject(ApiService);
  private readonly endpoint = '/api/Dashboard/PostosEstatisticas';

  obterPostosEstatisticas(): Observable<PostoEstatisModel> {
    return this.apiService.get<PostoEstatisModel>(this.endpoint);
  }
}

// SERVICE PARA O BADGE DE OCORRÊNCIAS
@Injectable({
  providedIn: 'root',
})
export class OcorrenciaEstatisticas {
  private readonly apiService = inject(ApiService);
  private readonly endpoint = '/api/Dashboard/OcorrenciasEstatisticas';

  obterOcorrenEstatisticas(): Observable<OcorrenciaEstaModel> {
    return this.apiService.get<OcorrenciaEstaModel>(this.endpoint);
  }
}

// SERVICE PARA O BADGE DE EFECTIVOS
@Injectable({
  providedIn: 'root',
})
export class EfetivoEstatisticas {
  private readonly apiService = inject(ApiService);
  private readonly endpoint = '/api/DashBoard/EfetivosEstatisticas';

  obterEfetivoEstatisticas(): Observable<EfetivoEstatisModel> {
    return this.apiService.get<EfetivoEstatisModel>(this.endpoint);
  }
}

// SERVICE PARA O BADGE DE CLIENTES
@Injectable({
  providedIn: 'root',
})
export class ClientesEstatisticas {
  private readonly apiService = inject(ApiService);
  private readonly endpoint = '/api/DashBoard/ClientesEstatisticas';

  obterClienteEstatisticas(): Observable<ClientesEstatisModel> {
    return this.apiService.get<ClientesEstatisModel>(this.endpoint);
  }
}
